<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eK7Odm/tc-custom/9781524866211.jpg?1704761626321" alt="This image is the cover for the book Small Fiction"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Small Fiction
      </h1>
      <p class="bookDescription body article font2">
        <b>From the popular Twitter account @ASmallFiction, “simultaneously succinct and powerful. You’ll be thinking about these stories long after you read them.” (Matthew Inman,#1 <i>New York Times </i>bestselling author of <i>How To Tell if Your Cat is Plotting to Kill You</i>)</b><br/><br/>For fans of the popular Twitter account @ASmallFiction comes a little book with a lot of big stories and images; some funny, some scary, but always thought-provoking! From the humorous to the bleak, the dystopian to the dog-filled, there’s a story for every occasion, and an occasion for every story. With stories told in 140 characters or less, <i>A Small Fiction</i> delivers brilliant yet brief tales destined to stick with readers long after they turn the page. Through the genre lenses of science fiction, fantasy, contemporary fiction, folklore, and humor, each of these illustrated micro-fictions is a peephole that reveals a bigger world.<br/><br/>“James had created a beautiful world that's about to end. It's also haunted and populated by depressed robots and even more depressed people. It made me laugh, think and cry, and I think those are just about the nicest things a book can do. Also there are aliens, if you're into that sort of thing.” —Iain Thomas, author of <i>I Wrote This For You</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Mark Miller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c91e79d6